import type {
  MarketingRouterRule as ContractMarketingRouterRule,
  MarketingRouterVariant,
} from '@luxuryescapes/contract-svc-promo/marketing-router/admin';

export type MarketingRouterRuleVariant = MarketingRouterVariant;

export type MarketingRouterRuleSignificanceMetric = 'ttv' | 'margin' | 'conversion';

type MarketingRouterRuleMatch = Required<
  Pick<ContractMarketingRouterRule['match'], 'utm_source' | 'utm_medium' | 'utm_campaign'>
> &
  Omit<ContractMarketingRouterRule['match'], 'utm_source' | 'utm_medium' | 'utm_campaign'>;

export type MarketingRouterRule = Omit<ContractMarketingRouterRule, 'significance_metrics' | 'match'> & {
  significance_metrics: Array<MarketingRouterRuleSignificanceMetric>;
  match: MarketingRouterRuleMatch;
};

export function getMarketingRouterRuleCookieName(ruleId: string, variantId: string): string {
  return `${ruleId}_${variantId}`;
}
